/**
 * Lazy background videos.
 *
 * `snippets/lazy-background-video.liquid` renders a single muted autoplay
 * <video> with no `src`, plus `data-src-desktop` / `data-src-mobile`. This
 * script sets `src` only once the video nears the viewport, picking the URL
 * that matches the current breakpoint, so a page never downloads a video that
 * is off-screen or meant for the other breakpoint. The `autoplay` attribute
 * starts playback once the source is set.
 *
 * Videos inserted after load (the collection section swaps its
 * `[data-partial]` innerHTML on filter / sort / pagination, the theme editor
 * re-renders sections) are picked up through a childList MutationObserver.
 */
(function () {
  if (window.__skuLazyBackgroundVideo) return;
  window.__skuLazyBackgroundVideo = true;

  var SELECTOR = 'video[data-lazy-background-video]';
  // Same breakpoint as the .video-hero__video-desktop / -mobile rules in theme.css.
  var desktopMedia = window.matchMedia('(min-width: 960px)');

  function sourceFor(video) {
    var mobileSrc = video.getAttribute('data-src-mobile');
    if (mobileSrc && !desktopMedia.matches) return mobileSrc;
    return video.getAttribute('data-src-desktop');
  }

  function load(video) {
    var src = sourceFor(video);
    if (!src || video.getAttribute('src') === src) return;

    // Keep a video the visitor paused paused when the breakpoint swaps it.
    var pausedByVisitor = video.hasAttribute('src') && video.paused;
    video.setAttribute('src', src);
    if (pausedByVisitor) video.pause();
  }

  var observer =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              observer.unobserve(entry.target);
              load(entry.target);
            });
          },
          { rootMargin: '200px 0px' }
        )
      : null;

  function watch(video) {
    if (observer) observer.observe(video);
    else load(video);
  }

  function init(root) {
    if (root.matches && root.matches(SELECTOR)) watch(root);
    var videos = root.querySelectorAll(SELECTOR);
    for (var i = 0; i < videos.length; i++) watch(videos[i]);
  }

  desktopMedia.addEventListener('change', function () {
    var videos = document.querySelectorAll(SELECTOR + '[src]');
    for (var i = 0; i < videos.length; i++) load(videos[i]);
  });

  if ('MutationObserver' in window) {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (added[j].nodeType === 1) init(added[j]);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  init(document);
})();
